import { differenceInCalendarDays, parseISO, format } from "date-fns";

export const DUE_SOON_THRESHOLD_DAYS = 3;

export const SHELF_LIFE_PRESETS = [
  { label: "2 weeks", days: 14 },
  { label: "1 month", days: 30 },
  { label: "3 months", days: 90 },
  { label: "6 months", days: 180 },
  { label: "1 year", days: 365 },
];

export function getDaysUntilExpiry(expiryDate) {
  return differenceInCalendarDays(parseISO(expiryDate), new Date());
}

export function getReminderUrgency(reminder) {
  const daysUntilExpiry = getDaysUntilExpiry(reminder.expiryDate);

  if (daysUntilExpiry < 0) {
    return "OVERDUE";
  }
  if (daysUntilExpiry <= DUE_SOON_THRESHOLD_DAYS) {
    return "DUE_SOON";
  }
  return "FRESH";
}

export function getUrgencyLabel(reminder) {
  const daysUntilExpiry = getDaysUntilExpiry(reminder.expiryDate);

  if (daysUntilExpiry < 0) {
    const daysOverdue = Math.abs(daysUntilExpiry);
    return `Overdue by ${daysOverdue} day${daysOverdue === 1 ? "" : "s"}`;
  }
  if (daysUntilExpiry === 0) {
    return "Expires today";
  }
  if (daysUntilExpiry <= DUE_SOON_THRESHOLD_DAYS) {
    return `${daysUntilExpiry} day${daysUntilExpiry === 1 ? "" : "s"} left`;
  }
  if (daysUntilExpiry < 30) {
    const weeks = Math.round(daysUntilExpiry / 7);
    return `Expires in ${weeks} week${weeks === 1 ? "" : "s"}`;
  }
  const months = Math.round(daysUntilExpiry / 30);
  return `Expires in ${months} month${months === 1 ? "" : "s"}`;
}

export function getMadeOrBoughtLabel(reminder) {
  return format(parseISO(reminder.madeOrBoughtDate), "MMM d");
}

export function getDurationLabel(durationDays) {
  const matchingPreset = SHELF_LIFE_PRESETS.find(
    (preset) => preset.days === durationDays,
  );
  if (matchingPreset) {
    return matchingPreset.label;
  }
  if (durationDays < 14) {
    return `${durationDays} day${durationDays === 1 ? "" : "s"}`;
  }
  if (durationDays < 60) {
    const weeks = Math.round(durationDays / 7);
    return `${weeks} week${weeks === 1 ? "" : "s"}`;
  }
  const months = Math.round(durationDays / 30);
  return `${months} month${months === 1 ? "" : "s"}`;
}

export function sortRemindersByUrgency(reminders) {
  return [...reminders].sort(
    (a, b) => getDaysUntilExpiry(a.expiryDate) - getDaysUntilExpiry(b.expiryDate),
  );
}

export function getAlertCount(reminders) {
  return reminders.filter((reminder) => {
    const urgency = getReminderUrgency(reminder);
    return urgency === "OVERDUE" || urgency === "DUE_SOON";
  }).length;
}
